import React, { useEffect, useMemo, useState } from 'react';
import '../styles.css';

const Lightbox = ({ isOpen, images, startIndex = 0, onClose }) => {
  const [index, setIndex] = useState(startIndex);

  const safeImages = useMemo(() => (images || []).map((it) => (typeof it === 'string' ? { src: it } : it)), [images]);
  const total = safeImages.length;
  const current = total > 0 ? safeImages[Math.min(Math.max(index, 0), total - 1)] : null;

  useEffect(() => { setIndex(startIndex); }, [startIndex]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
      if (e.key === 'ArrowRight') setIndex((i) => (i + 1) % total);
      if (e.key === 'ArrowLeft') setIndex((i) => (i - 1 + total) % total);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, total, onClose]);

  if (!isOpen || total === 0) return null;

  return (
    <div className="lightbox-overlay" role="dialog" aria-modal="true" onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <button className="lightbox-close" aria-label="Close" onClick={onClose}>×</button>
      <button className="lightbox-arrow left" aria-label="Previous" onClick={() => setIndex((i) => (i - 1 + total) % total)}>
        ‹
      </button>
      <div className="lightbox-content">
        {current?.src && (
          <img src={current.src} alt={current?.description || 'Artwork'} className="lightbox-image" />
        )}
        {current?.description && (
          <div className="lightbox-caption">{current.description}</div>
        )}
        <div className="lightbox-counter">{index + 1} / {total}</div>
      </div>
      <button className="lightbox-arrow right" aria-label="Next" onClick={() => setIndex((i) => (i + 1) % total)}>
        ›
      </button>
    </div>
  );
};

export default Lightbox;


